import React, { useState } from 'react';
import DocumentShow from 'components/UploadedFiles/DocumentShow';

function PreviewAllAttachments({
  uploadType,
  docs,
  delAttachmentModal,
  taskDetail,
  fro,
  selectedDocument,
  closePreview,
  readOnly,
  years,
  months,
  tags,
}) {
  const [selectedIndex, setSelectedIndex] = useState(
    docs.findIndex((doc) => doc.id === selectedDocument.id)
  );

  function handleNavigate(index) {
    setSelectedIndex(index);
  }

  return (
    <DocumentShow
      token={docs[selectedIndex]?.file_share_url}
      uploadType={uploadType}
      documents={docs}
      currentIndex={selectedIndex}
      enableNavigation
      onNavigate={handleNavigate}
      delAttachmentModal={delAttachmentModal}
      onButtonClose={closePreview}
      taskDetail={taskDetail}
      fro={fro}
      years={years}
      months={months}
      tags={tags}
      readOnly={readOnly}
    />
  );
}

export default PreviewAllAttachments;
